module.exports = __webpack_public_path__ + "img/76.a03d0ed0.png";